import { TextSlider } from '../components/atoms/textSliders'
import { Background, Card, ImageWrapper, TestimonialContainer } from '../components/testimonials'
import { Header48, Paragraph16 } from '../styles/typography'
import testimonialImage from '../assets/images/services/siding.jpg'

const data = [
    {
        Name: 'Suzanne G',
        Testimonial:
            'Jason is amazing! 10 out of 10. I hired JB Fineline Construction to renovate my garage, and I couldn’t be happier with the results. From the very beginning, he’s professional, communicative, and clearly knowledgeable.',
    },
    {
        Name: 'Linda M',
        Testimonial: `JB Fine Line Construction did an amazing job putting new siding and windows on our house. Our exterior of our house looks incredible, and you can't find nicer guys to have work for you. I would recommend them a 💯 percent.`,
    },
    {
        Name: 'Ximena B',
        Testimonial: `I can't be any happier with the final results of my project. The commitment and high proficiency of JB Fine Line Construction made my ideas came to reality in an better way that I was planning. My gratitude and high reference for them are minimal to the constant gratitude for the end res`,
    },
]

export function Testimonials() {
    return (
        <>
            <Background>
                <TestimonialContainer>
                    <Card>
                        <div style={{ gap: '16px', margin: '32px' }}>
                            <div>
                                <h3 style={{ color: '#324C77' }}>Testimonials</h3>
                                <h4 style={{ color: '#63665B', marginBottom: '8px' }}>
                                    Here are a few testimonials from customers who have worked with us before.
                                </h4>
                            </div>

                            <TextSlider textContent={data} />
                        </div>
                    </Card>
                </TestimonialContainer>
                <ImageWrapper src={testimonialImage} />
            </Background>
        </>
    )
}
